import React from 'react';

export default function LocationProctoringIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="44" height="44" rx="8" fill="#FBEFED"/>
<rect width="24" height="24" transform="translate(10 10)" fill="#FCEBE8"/>
<path d="M15 24.2864C13.1486 25.1031 12 26.2412 12 27.5C12 29.9853 16.4772 32 22 32C27.5228 32 32 29.9853 32 27.5C32 26.2412 30.8514 25.1031 29 24.2864M28 18C28 22.0637 23.5 24 22 27C20.5 24 16 22.0637 16 18C16 14.6863 18.6863 12 22 12C25.3137 12 28 14.6863 28 18ZM23 18C23 18.5523 22.5523 19 22 19C21.4477 19 21 18.5523 21 18C21 17.4477 21.4477 17 22 17C22.5523 17 23 17.4477 23 18Z" stroke="#667085" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


  );
}